export default "__VITE_ASSET__Dpc$cNKu__"